import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16v3z"
}), 'TransitEnterexitOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TransitEnterexitOutlined.js
// module id = 6910
// module chunks = 2